import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { User } from 'src/app/shared/models';
import { AuthService } from 'src/app/shared/service/auth/auth.service';
import { EventsService } from 'src/app/shared/service/events/events.service';
import { FirestoreService } from 'src/app/shared/service/firestore/firestore.service';
import { NavService } from 'src/app/shared/service/nav.service';
import { NotificationService } from 'src/app/shared/service/notification/notification.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  public loginForm: UntypedFormGroup;
  public registerForm: UntypedFormGroup;
  public active = 1;

  returnUrl: any;
  sub1: Subscription;
  email = '';
  password: any = '';
  user = new User();
  data: any = {};
  background: any = { 'background': 'url(/assets/images/jewellery/pro/12.jpg) no-repeat center center/ cover' };
  background_image: any = { 'background': 'url(/assets/images/jewellery/pro/12.jpg) no-repeat 0 0 / cover' };
  type_input: string = 'password';
  icon: string = 'eye';

  private navSubscription: Subscription;
  private userPathSubscription: Subscription;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private event: EventsService,
    private auth: AuthService,
    private firestore: FirestoreService,
    private notification: NotificationService,
    private navService: NavService
  ) {
    this.createLoginForm();
    this.createRegisterForm();

    if (localStorage.getItem('background') && localStorage.getItem('background_image')) {
      var objeto1 = localStorage.getItem('background');
      var objeto2 = localStorage.getItem('background_image');

      this.background = objeto1.hasOwnProperty('background') ? JSON.parse(localStorage.getItem('background')) : { 'background': 'url(/assets/images/jewellery/pro/12.jpg) no-repeat center center/ cover' };
      this.background_image = objeto2.hasOwnProperty('background') ? JSON.parse(localStorage.getItem('background_image')) : { 'background': 'url(/assets/images/jewellery/pro/12.jpg) no-repeat 0 0 / cover' };
    } else {
      this.background = { 'background': 'url(/assets/images/jewellery/pro/12.jpg) no-repeat center center/ cover' };
      this.background_image = { 'background': 'url(/assets/images/jewellery/pro/12.jpg) no-repeat 0 0 / cover' };
    }

    this.firestore.getOne('settings', 'admin').subscribe(res => {
      // console.log("settings: ",res);
      // console.log("background: ",this.background);
      if (res) {
        this.data = res;
        this.background = { 'background': 'url(' + this.data.background_image_login_sm + ') no-repeat center center/ cover' }
        this.background_image = { 'background': 'url(' + this.data.background_image_login + ') no-repeat 0 0 / cover' }
        localStorage.setItem('background', JSON.stringify(this.background));
        localStorage.setItem('background_image', JSON.stringify(this.background_image));
      }
    })
  }

  owlcarousel = [
    {
      title: "Super Admin",
      desc: "Bienvenido Accede a tu cuenta.",
    }
  ]
  owlcarouselOptions = {
    loop: false,
    items: 1,
    dots: false
  };

  createLoginForm() {
    this.loginForm = this.formBuilder.group({
      userName: [''],
      password: [''],
    })
  }
  createRegisterForm() {
    this.registerForm = this.formBuilder.group({
      userName: [''],
      password: [''],
      confirmPassword: [''],
    })
  }


  ngOnInit() {
  }

  onSubmit() {

  }

  async onLoggedin(e: Event) {
    // e.preventDefault();
    // localStorage.setItem('isLoggedin', 'true');
    // if (localStorage.getItem('isLoggedin')) {
    //   this.router.navigate([this.returnUrl]);
    // }

    Swal.fire({
      icon: 'info',
      title: 'Espera por favor...',
      showConfirmButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false,
      timerProgressBar: true,
      timer: 6e3
    })

    await this.auth.loginWithEmail(this.email, this.password).then(res => {
      // console.log("loginWithEmail: ",res);
      this.auth.getUser2().then(async userLocal => {
        if (res.user.emailVerified || userLocal.is_skipVerification) {
          // console.log("Email verified");
          console.log("getUser2: ",userLocal);
          if (userLocal.is_super || userLocal.is_super_guest) {
            if (res.user.emailVerified || userLocal.emailVerified) {
              this.user = userLocal;
              localStorage.setItem('isLoggedin', 'true');
              // localStorage.setItem('session_last_email', this.user.email);
              // localStorage.setItem('session_last_password', this.password)
              this.event.publish('session-start', true);
              localStorage.setItem('session_type', 'correo');
  
              // console.log("getUser2: ",userLocal)
              if (userLocal.is_enabled === true) {
                // localStorage.setItem('data_session',JSON.stringify({}));
                this.event.publish('user:session', true);
  
                Swal.close();
                Swal.fire(
                  'Bienvenido!',
                  'Bienvenido de vuelta!',
                  'success'
                )
                if (!userLocal.is_super) {
                  if (this.navSubscription) { this.navSubscription.unsubscribe(); }
                  if (this.userPathSubscription) { this.userPathSubscription.unsubscribe(); }

                  this.navSubscription = this.firestore.getWhere('nav_menu_permissions', 'is_super', true).subscribe(resNav => {
                    if (resNav) {
                      let filterHome = resNav.find(item => item.path === '/dashboard/default');
                      if (filterHome) {
                        this.userPathSubscription = this.firestore.getOnePath('nav_menu_permissions/' + filterHome.id + '/users/' + userLocal.uid).subscribe(res1 => {
                          if (res1 !== undefined) {
                            if (res1.view === true) {
                              this.router.navigate(['/dashboard/default']);
                            } else {
                              this.validatePathInit(resNav);
                            }
                          } else {
                            this.validatePathInit(resNav);
                          }
                        });
                      }
                    }
                  });
                } else {
                  this.router.navigate(['/dashboard/default']);
                }
              } else {
                Swal.close();
                Swal.fire(
                  'No puedes ingresar por el momento',
                  'Tu cuenta se encuentra deshabilitada',
                  'warning'
                )
                // this.router.navigate(['/verification']);
              }
            } else {
              Swal.close();
              Swal.fire(
                'No puedes ingresar por el momento',
                "Verifica tu correo o intentalo mas tarde",
                'warning'
              )
            }
          } else {
            Swal.close();
            Swal.fire(
              'Warning',
              "No puedes ingresar!",
              'warning'
            )
          }
          
        } else {
          Swal.close();
          Swal.fire(
            'Warning',
            "Confirme su dirección de correo electrónico",
            'warning'
          )
          // this.presentAlert("Error","Please confirm your email");
        }
      }).catch((e) => {
        Swal.close();
        Swal.fire(
          'Error',
          e,
          'error'
        )
      });
    }).catch(e => {
      console.log("loginWithEmail: ", e.message);
      Swal.close();
      Swal.fire(
        'Error',
        'Usuario o contraseña incorrectos.',
        'error'
      )
    });
  }

  async validatePathInit(menuItems_data) {
    let menuItems;
    const menuObservable = await this.navService.navPermissionUser(menuItems_data, this.user);
    menuObservable.subscribe(updatedMenuItems => {
      menuItems = updatedMenuItems;
      console.log('uodate: ', updatedMenuItems);
      menuItems = this.navService.cleanMenuItems(menuItems);
  
      if (menuItems) {
        menuItems.forEach(element => {
          console.log('ele: ', element);
          if(element.hasOwnProperty('is_super') && element.is_super) {
            if (element.type === 'sub') {
              element.children.forEach((child, index) => {
                let path = (child.path).replace(new RegExp('/', 'g'), '');
                return this.router.navigate([path]);
              });
            } else {
              return this.router.navigate([element.path]);
            }
          }
        });
      }
    });
  }

  ShowPassword() {
    // console.log("password");
    if (this.type_input === "password") {
      this.type_input = "text";
      this.icon = "eye-off";
    } else {
      this.type_input = "password";
      this.icon = "eye";
    }
  }

  async askResetPass() {
    await Swal.fire({
      title: "Ingresa tu correo!",
      icon: 'info',
      input: 'text',
      inputAttributes: {
        autocapitalize: 'off'
      },
      showCancelButton: true,
      showLoaderOnConfirm: true,
      confirmButtonText: 'Continuar',
      denyButtonText: `Cancelar`,
      allowOutsideClick: () => !Swal.isLoading()
    }).then((result) => {
      // console.log("result: ", result);
      if (result.isConfirmed) {
        if (result.value !== '') {
          Swal.fire({
            icon: 'info',
            title: 'Espera por favor...',
            showConfirmButton: false,
            allowOutsideClick: false,
            allowEscapeKey: false,
            timerProgressBar: true,
            timer: 6e3
          });
          this.auth.resetPassword(result.value).then(r => {
            Swal.close();
            Swal.fire(
              'Revisa tu correo',
              'Hemos enviado un link de cambio de contraseña',
              'success'
            )
          }).catch(err => {
            console.log(err)
            Swal.close();
            Swal.fire(
              'Error',
              err.message,
              'error'
            )
          });
        } else {
          Swal.close();
          Swal.fire(
            'Completa el campo',
            '',
            'warning'
          )
        }
      }
    })

  }


}
